import { render, staticRenderFns } from "./JoinNftGatedCast.vue?vue&type=template&id=1ded5d0a&scoped=true&"
import script from "./JoinNftGatedCast.vue?vue&type=script&lang=js&"
export * from "./JoinNftGatedCast.vue?vue&type=script&lang=js&"
import style0 from "./JoinNftGatedCast.vue?vue&type=style&index=0&id=1ded5d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded5d0a",
  null
  
)

export default component.exports